import { format } from 'date-fns';
import { HomeIcon } from '@heroicons/react/24/outline';
import { de, enUS } from 'date-fns/locale';

interface TripEndMarkerProps {
  endDate: string;
  sortOrder: 'ASC' | 'DESC';
}

export const TripEndMarker = ({ endDate, sortOrder }: TripEndMarkerProps) => {
  const end = new Date(endDate);

  const endDateText =
    !navigator.language || !navigator.language.startsWith('de')
      ? format(end, 'MMMM d, yyyy', { locale: enUS })
      : format(end, 'd. MMMM yyyy', { locale: de });

  const dateText = (
    <div className="my-4 flex flex-col items-center text-sm text-subtle">
      <span>
        <HomeIcon className="w-5 h-5" />
      </span>
      <p>{endDateText}</p>
    </div>
  );

  const connectorLine = (
    <div
      className={`w-0.5 h-20 ${
        sortOrder === 'DESC'
          ? 'bg-gradient-to-b from-gray-400 to-transparent'
          : 'bg-gradient-to-t from-gray-400 to-transparent'
      }`}
    />
  );

  return (
    <div className="flex flex-col items-center">
      {sortOrder === 'DESC' ? (
        <>
          {dateText}
          {connectorLine}
        </>
      ) : (
        <>
          {connectorLine}
          {dateText}
        </>
      )}
    </div>
  );
};
